import React from 'react';
import { View, Text, Pressable, StyleSheet, ActivityIndicator } from 'react-native';
import { ArrowRight } from '../../lib/icons';

interface NavigationButtonsProps {
  currentStep: number;
  loading: boolean;
  onBack: () => void;
  onContinue: () => void;
  canContinue: boolean;
  continueButtonText?: string;
  loadingText?: string;
}

export const NavigationButtons = ({
  currentStep,
  loading,
  onBack,
  onContinue,
  canContinue,
  continueButtonText = 'Continue',
  loadingText
}: NavigationButtonsProps) => {
  return (
    <View style={styles.navigation}>
      <Pressable
        onPress={onBack}
        disabled={currentStep === 0}
        style={[styles.navButton, styles.backButton, currentStep === 0 && styles.navButtonDisabled]}
      >
        <Text style={[styles.navButtonText, currentStep === 0 && styles.navButtonTextDisabled]}>
          Back
        </Text>
      </Pressable>
      <Pressable
        onPress={onContinue}
        disabled={loading || !canContinue}
        style={[styles.navButton, styles.continueButton, (loading || !canContinue) && styles.navButtonDisabled]}
      >
        {loading ? (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="small" color="#ffffff" />
            <Text style={styles.continueButtonText}>
              {loadingText || 'Loading...'}
            </Text>
          </View>
        ) : (
          <View style={styles.buttonContent}>
            <Text style={styles.continueButtonText}>
              {continueButtonText}
            </Text>
            <ArrowRight size={16} color="#ffffff" />
          </View>
        )}
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  navigation: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 32,
  },
  navButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  backButton: {
    backgroundColor: 'transparent',
  },
  navButtonDisabled: {
    opacity: 0.5,
  },
  navButtonText: {
    fontSize: 14,
    color: '#4b5563',
  },
  navButtonTextDisabled: {
    color: '#9ca3af',
  },
  continueButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: '#000000',
    borderRadius: 8,
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  loadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  continueButtonText: {
    color: '#ffffff',
    fontSize: 16,
    fontWeight: '500',
  },
});
